import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  CardGroup,
  Col,
  Container,
  Form,
  FormGroup,
  FormFeedback,
  Input,
  Row,
} from 'reactstrap';
import { toastr } from 'react-redux-toastr';

import ApiHelper from '../../utils/apiHelper';
import { validateEmail } from '../../utils/commonHelper';
import AuthHelper from '../../utils/authHelper';
import * as constants from '../../utils/constants';

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messageSent: false,
      errors: {
        email: '',
      },
    };
  }

  handleChangeInput = (e) => {
    let errors = this.state.errors;
    if (errors[e.target.name] !== '') {
      errors[e.target.name] = '';
      this.setState(errors);
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    let email = e.target.elements.email.value.toLowerCase();
    let errors = this.state.errors;

    if (email === '') {
      errors.email = 'Email address is required';
      this.setState(errors);
      return;
    }

    if (!validateEmail(email)) {
      errors.email = 'Email address is invalid.';
      this.setState({ errors });
      return;
    }

    ApiHelper.post(
      '/api/auth/password_reset/',
      {
        email,
      },
      {},
      false,
    )
      .then((res) => {
        this.setState({ messageSent: true });
      })
      .catch((err) => {
        errors.email =
          'There is no active user associated with this email address or the password can not be changed.';
        this.setState({ errors });
        toastr.error('Fail!', 'Failed to send password reset link.');
      });
  };

  render() {
    const { logoUrl, isAuthenticated } = this.props;

    if (isAuthenticated) {
      return <Redirect to="/" />;
    }

    const { errors, messageSent } = this.state;
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <Form onSubmit={this.handleSubmit}>
                      <div className="text-center">
                        <Link to="/">
                          <img src={logoUrl} height={150} alt="logo" />
                        </Link>
                      </div>

                      {!messageSent ? (
                        <React.Fragment>
                          <span className="h5">
                            Please enter your email address and we will send you
                            a link to reset your password.
                          </span>
                          <FormGroup className="mt-2">
                            <Input
                              type="text"
                              placeholder="Email address"
                              name="email"
                              invalid={errors.email !== ''}
                              onChange={this.handleChangeInput}
                            />
                            <FormFeedback>{errors.email}</FormFeedback>
                          </FormGroup>
                          <Row>
                            <Col>
                              <Button block color="primary" size="lg">
                                Send password reset email
                              </Button>
                            </Col>
                          </Row>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <Row className="mb-2">
                            <Col>
                              <span className="h5">
                                Check your email for a message with a link to
                                update your password. This link will expire in
                                an hour.
                              </span>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <Button
                                block
                                color="primary"
                                size="lg"
                                onClick={() =>
                                  this.props.history.push('/login')
                                }
                              >
                                Continue to Login
                              </Button>
                            </Col>
                          </Row>
                        </React.Fragment>
                      )}
                    </Form>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isAuthenticated: AuthHelper.isAuthenticated(state.auth),
  logoUrl: state.settings.logoUrl
    ? state.settings.logoUrl
    : constants.DEFAULT_LOGO_URL,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
